<template>
  <vxe-modal v-model="visible" :loading="loading" :title="$t('menu.inventoryStateConfig')" type="confirm" width="50%" @confirm="confirm">
    <a-form-model ref="form" :colon="false" :label-col="{ span: 8 }" :model="data" :rules="rules" :wrapper-col="{ span: 16 }">
      <a-row style="margin-left: -4%;margin-right: 4%">
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.orderTypeNo')">
            <vxe-input v-model="data.orderType.no" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.orderTypeName')">
            <vxe-input v-model="data.orderType.name" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.inventoryState')" prop="inventoryState">
            <vxe-select v-model="data.inventoryState" :options="inventoryStates" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.defaults')">
            <vxe-switch v-model="data.defaults"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.warehouse')">
            <vxe-select v-model="data.warehouse.id" :options="warehouses" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.owner')">
            <vxe-select v-model="data.owner.id" :options="owners" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </vxe-modal>
</template>

<script>
import Vue from 'vue'
import { ENTERPRISE } from '@/store/mutation-types'
import { findOne, save } from '@/api/Api'
import { InventoryStateConfig } from '@/api/dto/config/InventoryStateConfig'

export default {
  name: 'InventoryStateConfigEditor',
  props: {
    inventoryStates: { type: Array, default: () => [] },
    warehouses: { type: Array, default: () => [] },
    owners: { type: Array, default: () => [] }
  },
  data() {
    return {
      enterprise: Vue.ls.get(ENTERPRISE),
      visible: false,
      loading: false,
      data: new InventoryStateConfig(),
      rules: {
        inventoryState: [{ required: true, message: this.$t('message.canNotBeEmpty') }]
      }
    }
  },
  methods: {
    add(type) {
      this.visible = true
      this.data = new InventoryStateConfig()
      this.data.orderType = type
    },
    edit(id, copy) {
      this.visible = true
      this.loading = true
      findOne('inventoryStateConfigFactory', { id: id }).then(res => {
        if (res.success) {
          if (copy) {
            res.result.id = undefined
            res.result.version = undefined
          }
          this.data = new InventoryStateConfig(res.result)
        }
      }).finally(() => this.loading = false)
    },
    save() {
      this.loading = true
      const data = this.data.toJSONObject()
      data.enterprise = this.enterprise
      save('inventoryStateConfigPersister', data).then(res => {
        if (res.success) {
          this.data = new InventoryStateConfig(res.result)
          this.$message.success(this.$t('message.saveSuccess'))
          this.$emit('success')
          this.visible = false
        }
      }).finally(() => this.loading = false)
    },
    confirm() {
      this.$refs.form.validate((success) => {
        if (success) this.save()
      })
    }
  }
}
</script>